import { Component, AfterViewInit, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { environment } from 'src/environments/environment';
import Amplify from '@aws-amplify/core';
import { AuthService } from 'src/core/services/auth.service';
import { NavigationEnd, Router } from "@angular/router";
import { UtilsService } from 'src/core/services/utils.service';
import { CognitoUserInterface } from '@aws-amplify/ui-components';

Amplify.configure({
  Auth: environment.auth
});


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'magalies-pharma';
  init: boolean = false;
  is_dark = false;

  // for side nav
  fixedTopGap: number = 0;

  currentUser: CognitoUserInterface | null = null;
  currentRoles: string[] = [];
  showAccountDetails: boolean = false;
  style: string = ""

  constructor(
    private _auth: AuthService,
    private _router: Router,
    private location: Location,
    private utils: UtilsService
  ) { }


  async ngOnInit() {

    this.init = await this._auth.authenticateUser();

    this
      ._auth
      .currentUserChanges()
      .subscribe((user) => {
        this.currentUser = user;
        if (this.currentUser) {
          if (this.location.path() === '/portal') {
            this._router.navigate(['/portal/dashboard']);
          } 
        }
      });

    this
      ._auth
      .currentRolesChanges()
      .subscribe((roles) => {
        this.currentRoles = roles;
      });

    this
      .utils
      .onMainNavHeightChanged()
      .subscribe(height => {
        this.fixedTopGap = height;
        this.style = `margin-top: ${this.fixedTopGap + 10}px`;
      });

    this._router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0)
    });
  }
  async signOut() {
    await this._auth.signOut();
  }


  getFirstLetterOfName(user: CognitoUserInterface | null) {
    if (!user) return ":/";
    return user.attributes.name[0];
  }

  autoCloseAccountDetails() {
    this.showAccountDetails = false;
  }
}
